import { createAsyncThunk } from "@reduxjs/toolkit";
import _ from "lodash";

import endpoints from "./endpoints";
import { sendRequest } from "./requests";

export const fetchLogbookFlights = createAsyncThunk(
  "logbook/fetchFlights",
  async (flightIds: string[]) => {
    const data = await sendRequest(endpoints.GET_FLIGHTS, { flightIds });
    // Logbook gets and returns uppercase flight ids, but somewhere before they are returned,
    // they get lowercased. Ids are uppercase everywhere else, and mixing cases would
    // break/complicate reducers and selectors. Easiest to re-uppercase them.
    return _.mapKeys(data, (_v, k) => k.toUpperCase());
  }
);

export const fetchLogbookFlight = createAsyncThunk(
  "logbook/fetchFlight",
  async (flightId: string) => {
    // uses the same endpoint as getLogbookFlights, expects a list of flightId
    const data = await sendRequest(endpoints.GET_FLIGHT, { flightIds: [flightId] });
    return _.mapKeys(data, (_v, k) => k.toUpperCase());
  }
);

export interface LogTaskPayload {
  flightId: string;
  logHandle: string;
}

export const ingestLog = createAsyncThunk(
  "logbook/ingestLog",
  async ({ logHandle }: LogTaskPayload) => {
    try {
      await sendRequest(endpoints.INGEST_LOG, { directory: logHandle });
    } catch (error) {
      throw error;
    }
  }
);

export const restoreLog = createAsyncThunk(
  "logbook/restoreLog",
  async ({ logHandle }: LogTaskPayload) => {
    try {
      await sendRequest(endpoints.RESTORE_LOG, { directory: logHandle });
    } catch (error) {
      throw error;
    }
  }
);
